import { LLMNode } from './llm-node'
import { CodeNode } from './code-node'
import { HttpNode } from './http-node'
import { AgentNode } from './agent-node'
import {
  StartNode,
  EndNode,
  TaskNode,
  RouterNode,
  JoinNode,
} from './control-nodes'

// Declared at module scope to avoid React Flow Pitfall 2:
// nodeTypes must not be recreated on every render.
export const nodeTypes = {
  llm: LLMNode,
  code: CodeNode,
  http: HttpNode,
  agent: AgentNode,
  start: StartNode,
  end: EndNode,
  task: TaskNode,
  router: RouterNode,
  join: JoinNode,
}
